// removed by extract-text-webpack-plugin
module.exports = {"assistentBtn":"_2g873v3Q5doaNldWeh-V_f","assistentBtn__circl":"_32R0hoyUWj7JqrWkzOLKfs","circle-size":"_2hutatgQwC2owDW-7JLDjs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AssistentBtn/style.css
// module id = 331
// module chunks = 0